import axios from 'axios';

const state = {
    template_manager: [],
    template_skin: [],
    sportToPrint: [],
    categoryToPrint: []
};

const getters = {
    getTemplateManager: state => state.template_manager,
    getTemplateSkin: state => state.template_skin,
    getSportToPrint: state => state.sportToPrint,
    getCategoryToPrint: state => state.categoryToPrint
};

const actions = {
    async fetchSportsPlayer({ rootGetters, commit }, payload) {
        try {
            const url = `${rootGetters['settings/getUrlApi']}/v3/sports/player?provider=lsport`;
            const res = await axios.get(url, {
                params: payload || {},
                headers: { Authorization: `Bearer ${rootGetters['settings/getToken']}` }
            });
            const data = res.data?.data || res.data || [];
            commit('SET_SPORT_TO_PRINT', data);
            return data;
        } catch (err) {
            throw err;
        }
    },

    async fetchSportMarkets({ rootGetters }, sportId) {
        try {
            const url = `${rootGetters['settings/getUrlApi']}/sport-market-mappings/sport/${sportId}`;
            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${rootGetters['settings/getToken']}` },
                params: { excludeSpecifier: false, sortBy: 'marketName' }
            });
            return res.data?.data || res.data || [];
        } catch (err) {
            throw err;
        }
    },

    async generatePreview({ rootGetters }, payload) {
        try {
            const url = `${rootGetters['settings/getUrlApi']}/v3/print-template/prints/templates/preview`;
            return await axios.post(url, payload, {
                headers: { Authorization: `Bearer ${rootGetters['settings/getToken']}` },
                responseType: 'blob'
            });
        } catch (err) {
            throw err;
        }
    },

    // NUOVA ACTION PER I TEMPLATE
    async fetchPrintTemplates({ rootGetters, commit }, platformId) {
        try {
            const url = `${rootGetters['settings/getUrlApi']}/v3/print-template/platforms/${platformId}/prints/templates`;
            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${rootGetters['settings/getToken']}` }
            });

            const templates = res.data?.result || res.data?.data || [];

            // Dividiamo i template del manager (platform 0) da quelli della skin
            const manager = templates.filter(t => String(t.platformId) === '0');
            const skin = templates.filter(t => String(t.platformId) !== '0');

            commit('SET_TEMPLATE_MANAGER', manager);
            commit('SET_TEMPLATE_SKIN', skin);

            return { managerPrintTemplates: manager, skinPrintTemplates: skin };
        } catch (err) {
            return { managerPrintTemplates: [], skinPrintTemplates: [] };
        }
    }
};

const mutations = {
    SET_TEMPLATE_MANAGER(state, payload) { state.template_manager = payload; },
    SET_TEMPLATE_SKIN(state, payload) { state.template_skin = payload; },
    SET_SPORT_TO_PRINT(state, payload) { state.sportToPrint = payload; },
    SET_CATEGORY_TO_PRINT(state, payload) { state.categoryToPrint = payload; }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};